import { FC } from 'react';
import Auth from '@aws-amplify/auth';
import storage from 'storage';
import { useQueryClient } from 'react-query';

const Logout: FC = () => {
  const queryClient = useQueryClient();

  async function logout() {
    await queryClient.cancelQueries();

    queryClient.clear();
    storage.removeAll();
    window.Intercom?.('shutdown');

    await Auth.signOut();
    location.replace('/');
  }

  void logout();

  return null;
};

export default Logout;
